import Link from "next/link";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Text,
} from "@chakra-ui/react";
import { HOME_FAQ, HOME_SECTION_IDS } from "./homeContent";
import { HomeCard, SectionContainer, SectionHeading, SectionShell } from "./homeUi";

export function HomeFaqSection() {
  return (
    <SectionShell id={HOME_SECTION_IDS.faq}>
      <SectionContainer>
        <SectionHeading
          eyebrow="FAQ"
          title="Perguntas frequentes sobre o sistema para barbearia"
          description="Respostas objetivas para entender como o Meu Barbeiro PRO funciona."
        />

        <Box maxW="3xl" mx="auto">
          <HomeCard p={{ base: 2, md: 4 }}>
            <Accordion allowToggle reduceMotion>
              {HOME_FAQ.map((item, index) => (
                <AccordionItem
                  key={item.question}
                  borderColor="whiteAlpha.100"
                  borderTop={index === 0 ? "none" : undefined}
                >
                  <h3>
                    <AccordionButton py={4} _hover={{ bg: "whiteAlpha.50" }}>
                      <Box flex="1" textAlign="left" fontWeight="semibold" color="white">
                        {item.question}
                      </Box>
                      <AccordionIcon color="orange.900" />
                    </AccordionButton>
                  </h3>
                  <AccordionPanel pb={4} color="barber.100" fontSize="sm">
                    {item.answer}
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </HomeCard>

          <Text textAlign="center" mt={6} color="barber.100" fontSize="sm">
            Ainda tem dúvidas?{" "}
            <Button
              as={Link}
              href="/home/faq"
              variant="link"
              color="orange.900"
              fontSize="sm"
            >
              Ver FAQ completo
            </Button>
          </Text>
        </Box>
      </SectionContainer>
    </SectionShell>
  );
}
